// Generated by purs version 0.15.15
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
var unwrap = /* #__PURE__ */ Data_Newtype.unwrap();
var withReader = Control_Monad_Reader_Trans.withReaderT;
var runReader = function (v) {
    return function ($4) {
        return unwrap(v($4));
    };
};
var mapReader = function (f) {
    return Control_Monad_Reader_Trans.mapReaderT(function ($5) {
        return Data_Identity.Identity(f(unwrap($5)));
    });
};
export {
    runReader,
    mapReader,
    withReader
};
export {
    ask,
    asks,
    local
} from "../Control.Monad.Reader.Class/index.js";
export {
    ReaderT,
    lift,
    mapReaderT,
    runReaderT,
    withReaderT
} from "../Control.Monad.Reader.Trans/index.js";
